import { ProductFormProvider } from "./contexts/ProductFormContext";
import { useProductForm } from "./hooks/useProductForm";
import { ProductInformationSection } from "./components/ProductInformationSection";
import { AttachmentsSection } from "./components/AttachmentsSection";
import { FormFooter } from "./components/FormFooter";
import { ProductFormHeader } from "./components/ProductFormHeader";
import useJStyles from "$hooks/useJStyles";
import { ProductFormProps } from "./types/Product.types";

const ProductForm = ({
  onSubmit,
  onReset,
  product,
  productError,
  defaultValuesForm = {},
  isSubmitting = false,
  company,
  isReferenced = true,
}: ProductFormProps) => {
  const { jclasses } = useJStyles();

  const { form, isAdmin, canEditRefP, isAReceptionRefProduct, currentCompany } =
    useProductForm(product, company, isReferenced, defaultValuesForm);

  const contextValue = {
    form,
    isAdmin,
    isSubmitting,
    canEditRefP,
    isAReceptionRefProduct,
    isReferenced,
    company,
    product,
    productError,
    currentCompany,
    defaultValuesForm,
    onReset,
  };

  return (
    <ProductFormProvider value={contextValue}>
      <div className={jclasses.jWrapper}>
        <form
          onSubmit={(e) => {
            e.stopPropagation();
            form.handleSubmit(onSubmit)(e);
          }}
          className={jclasses.form}
        >
          <div className={jclasses.formTop}>
            <ProductFormHeader />
          </div>

          <ProductInformationSection />

          {(!product || product.isActive) && <AttachmentsSection />}

          <FormFooter />
        </form>
      </div>
    </ProductFormProvider>
  );
};

export default ProductForm;
